import React, { useMemo, useState } from 'react';
import { IStory } from '../../common/types';
import {
  StyledStory,
  StoryImageWrapper,
  StoryImage,
  StoryImageThumbnail,
  StoryFooter,
  StoryFooterLeft,
  StoryFooterRight,
  StoryName,
  StoryDate,
  StyledButton,
} from './styled';
import { Modal } from '@unfold/modal';
import { StoryModal } from './StoryModal';
import format from 'date-fns/format';
import fromUnixTime from 'date-fns/fromUnixTime';
import { OptionsMenuIcon } from '@unfold/icon';

interface IStoryProps {
  story: IStory;
}

export const Story: React.FC<IStoryProps> = ({ story }) => {
  const lastSynced = useMemo(() => {
    const locale = window.navigator.language;
    const isUS = locale === 'en-US';
    return isUS
      ? format(fromUnixTime(story.updated_at), 'MMM dd, yyyy')
      : format(fromUnixTime(story.updated_at), 'dd/MM/yyyy');
  }, [story.updated_at]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOptionsClick = (): void => {
    setIsModalOpen(true);
  };

  const handleModalClose = (): void => {
    setIsModalOpen(false);
  };

  return (
    <>
      <StyledStory elevation="card">
        <StoryImageWrapper>
          {story.thumbnail ? (
            <StoryImage url={story.thumbnail}></StoryImage>
          ) : (
            <StoryImageThumbnail></StoryImageThumbnail>
          )}
        </StoryImageWrapper>
        <StoryFooter>
          <StoryFooterLeft>
            <StoryName>{story.title}</StoryName>
            <StoryDate>Last synced {lastSynced}</StoryDate>
          </StoryFooterLeft>
          <StoryFooterRight>
            <StyledButton
              appearance="subtle"
              iconBefore={<OptionsMenuIcon />}
              onClick={handleOptionsClick}
            ></StyledButton>
          </StoryFooterRight>
        </StoryFooter>
      </StyledStory>
      <Modal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        width={680}
        hasPadding={false}
      >
        <StoryModal story={story} />
      </Modal>
    </>
  );
};
